// extracted by mini-css-extract-plugin
export default {"ProgressLoader":"Progress_ProgressLoader__H8y3c","relative":"Progress_relative__CN7cw","colorSecondary":"Progress_colorSecondary__HRVue"};